// extracted by mini-css-extract-plugin
export default {"header":"_70iXQubYcXKTyV4cE3yeIC"};